<template>
    <div>
        <v-card class="pa-2 mb-2">
            <v-row>
                <v-btn color="primary" class="ml-4" :disabled="!$global.login.administrator || table.selected.length == 0" @click="onSetValuesClick"><v-icon left>mdi-content-save</v-icon>Set License Values ({{this.table.selected.length}})</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="!$global.login.administrator" @click="onEmailClick"><v-icon left>mdi-content-save</v-icon>Email Licenses</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mr-4" :disabled="!$global.login.administrator" @click="onCreateClick"><v-icon left>mdi-content-save</v-icon>Create Licenses</v-btn>
            </v-row>
        </v-card>

        <v-card class="mb-2">
            <v-card-title class="pa-2">
                <v-row>
                    <v-col>
                        <label><v-icon left>mdi-magnify</v-icon>Search</label>
                    </v-col>
                    <v-col cols="6">
                        <v-row>
                            <v-select :items="types" v-model="searchType" label="" class="type"></v-select>
                            <v-text-field ref="searchFor" label="Search Firm, License, System or User Part " prepend-inner-icon="mdi-magnify" v-model="searchFor" outlined dense single-line rounded clearable hide-details @keyup.native="onKey"></v-text-field>
                        </v-row>
                    </v-col>
                    <v-col>
                        <v-btn color="primary" class="ml-4" @click="confirmLoadLicenses"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <v-card>
            <v-card-title class="pa-2">
                <v-row>
                    <v-col>
                        <label><v-icon left>mdi-account</v-icon>Licenses</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="table.search" label="Filter on any field" prepend-inner-icon="mdi-filter-outline" outlined dense single-line rounded clearable hide-details v-show="table.licenses.length > 0"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="onAlternateClick" icon v-show="table.licenses.length > 0"><v-icon left>mdi-table</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-data-table dense ref="licensesTable" :footer-props="table.footerProps" v-model="table.selected" :single-select="table.singleSelect" item-key="licenseKey" show-select :items="table.licenses" :search="table.search" :loading="isBusy" :loading-text="table.loadingText" class="elevation-1" @click:row="onRowClick">
                <template v-slot:[`item.active`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.active)" dot></v-badge>
                </template>
                <template v-slot:[`item.expirationDate`]="{ item }">
                    <v-chip outlined :color="getDateColor(item.expires)" dark>{{ item.expires }}</v-chip>
                </template>
                <template v-slot:[`item.ifrs`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.ifrs)" dot></v-badge>
                </template>
                <template v-slot:[`item.grap`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.grap)" dot></v-badge>
                </template>
                <template v-slot:[`item.rac`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.rac)" dot></v-badge>
                </template>
                <template v-slot:[`item.cet`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.cet)" dot></v-badge>
                </template>
                <template v-slot:[`item.tvet`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.tvet)" dot></v-badge>
                </template>
                <template v-slot:[`item.cloud`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.cloud)" dot></v-badge>
                </template>
            </v-data-table>
        </v-card>
        <v-snackbar v-model="snackbar.visible" color="primary" :timeout="snackbar.timeout" :bottom="snackbar.bottom">
            {{snackbar.message}}
            <v-btn dark text @click="snackbar.visible=false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "LicenseSearch",
    data() {
        return {
            singleSelect: false,
            title: "Licenses",
            isBusy: false,
            snackbar: {
                visible: false,
                timeout: 3000,
                bottom: true,
                message: "",
            },
            searching: true,
            editingLicense: {
                installationKey: "",
                active: 0,
            },
            types: ["All", "Active", "Inactive"],
            searchType: "All",
            searchFor: "",
            table: {
                singleSelect: false,
                footerProps: { "items-per-page-options": [15, 25, 50, 100, 250] },
                selected: [],
                search: "",
                itemKey: "intallationGUID",
                loadingText: "loading licenses",
                header_set: 1,
                headers_1: [
                    {
                        text: "A", value: "active", width: "64px", align: "left",
                    },
                    { text: "Type", value: "licenseTypeGUID" },
                    { text: "License", value: "licenseKey" },
                    { text: "Tx", value: "transferredTo" },
                    { text: "Dealer", value: "dealerGUID" },
                    { text: "Firm", value: "firmGUID" },
                    { text: "Company", value: "firm" },
                    { text: "Name", value: "name" },
                    { text: "Email", value: "email" },
                    { text: "Expires", value: "expires" },
                    { text: "Pulse", value: "pulse" },
                    { text: "Notes", value: "noteCount" },
                ],
                headers_2: [
                    {
                        text: "A", value: "active", width: "64px", align: "left",
                    },
                    { text: "Type", value: "licenseTypeGUID" },
                    { text: "License", value: "licenseKey" },
                    { text: "Tx", value: "transferredTo" },
                    { text: "Dealer", value: "dealerGUID" },
                    { text: "Firm", value: "firmGUID" },
                    { text: "Company", value: "firm" },
                    { text: "Name", value: "name" },
                    { text: "Email", value: "email" },
                    { text: "Created", value: "created" },
                    { text: "Installed", value: "installed" },
                    { text: "Expires", value: "expires" },
                    { text: "Pulse", value: "pulse" },
                ],
                headers_3: [
                    {
                        text: "A", value: "active", width: "64px", align: "left",
                    },
                    { text: "Type", value: "licenseTypeGUID" },
                    { text: "License", value: "licenseKey" },
                    { text: "Tx", value: "transferredTo" },
                    { text: "Dealer", value: "dealerGUID" },
                    { text: "Firm", value: "firmGUID" },
                    { text: "Company", value: "firm" },
                    { text: "Name", value: "name" },
                    { text: "Email", value: "email" },
                    { text: "IFRS", value: "ifrs" },
                    { text: "GRAP", value: "grap" },
                    { text: "RAC", value: "rac" },
                    { text: "CET", value: "cet" },
                    { text: "TVET", value: "tvet" },
                    { text: "CLOUD", value: "cloud" },
                ],
                licenses: [],
            },
            dialog: false,
            months: ["Any", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        };
    },
    mounted() {
        this.$http
            .get(`/api/gui/pulse`)
            .catch((err) => {
                if (err.response.status === 401) {
                    this.$router.push({ name: "login" });
                }
            });

        this.setHeaders();
        this.table.selected = [];
    },
    methods: {
        onKey(evt) {
            if (evt.key === "Enter") {
                this.confirmLoadLicenses();
            }
        },
        onBackKey() {
            this.searching = true;
            this.table.selected = [];
        },
        onEmailClick() {
            this.$confirm({
                title: "Confirm Email",
                message: "Are you sure you wish to email all the licenses?",
            }, (value) => {
                if (value) {
                    this.emailLinceses();
                }
            });
        },
        confirmLoadLicenses() {
            if (this.searchFor === null) {
                this.searchFor = "";
            }
            if (this.searchFor === "") {
                this.$confirm({
                    title: "Confirm Search",
                    message: "Are you sure you wish to load the first 1000 licenses?",
                }, (value) => {
                    if (value) {
                        this.loadLincenses();
                    }
                });
            }
            else {
                this.loadLincenses();
            }
        },
        emailLinceses() {
            this.isBusy = true;

            this.$http
                .get("/api/license/email/")
                .then(() => {
                    this.isBusy = false;
                    this.snackbar.message = "Email Sent";
                    this.snackbar.visible = true;

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "email",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    this.$alert({ type: "error", title: "Email Failed", message: err.response.data.exceptionMessage });
                });
        },
        loadLincenses() {
            this.isBusy = true;
            this.table.licenses = [];
            this.table.selected = [];
            this.$http
                .get(`/api/license/search/${this.searchType}/${this.searchFor}/`)
                .then((response) => {
                    this.table.licenses = response.data;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "search",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                });
        },
        getActiveColor(active) {
            if (active === true) return "green";
            return "red";
        },
        getActiveIcon(active) {
            if (active === true) return "mdi-checkbox-marked-circle-outline";
            return "mdi-checkbox-blank-circle-outline";
        },
        getDateColor(date) {
            if (moment(date, "DD MMM YYYY") > moment()) return "green";
            return "red";
        },
        getCodeStart(code) {
            if (code.length > 5) return code.substring(0, 5);
            return code;
        },
        onRowClick(selectedItem) {
            this.$emit("onRowClick", selectedItem);
        },
        onCreateClick() {
            this.$emit("onCreateClick");
        },
        onSetValuesClick() {
            this.$emit("onSetValuesClick", this.table.selected);
        },
        onAlternateClick() {
            if (this.table.header_set === 1) {
                this.table.header_set = 2;
            }
            else if (this.table.header_set === 2) {
                this.table.header_set = 3;
            }
            else {
                this.table.header_set = 1;
            }
            this.setHeaders();
        },
        setHeaders() {
            if (this.table.header_set === 1) {
                this.$refs.licensesTable.headers = this.table.headers_1;
            }
            else if (this.table.header_set === 2) {
                this.$refs.licensesTable.headers = this.table.headers_2;
            }
            else if (this.table.header_set === 3) {
                this.$refs.licensesTable.headers = this.table.headers_3;
            }
        },
    },
};
</script>

<style>
.type {
    max-width: 96px;
    max-height: 18px;
    vertical-align: top;
    padding-top: 0px;
}
</style>
